if (!customElements.get('media-gallery')) {
    customElements.define(
        'media-gallery',
        class MediaGallery extends HTMLElement {
            constructor() {
                super();
                this.elements = {
                    liveRegion: this.querySelector('[id^="GalleryStatus"]'),
                    viewer: this.querySelector('[id^="GalleryViewer"]'),
                    thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
                };
                this.mql = window.matchMedia('(min-width: 750px)');
                if (!this.elements.viewer) return;

                this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));

                if (this.elements.thumbnails) {
                    this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
                        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
                    });
                }
            }

            onSlideChanged(event) {
                if (!this.elements.thumbnails) return;
                const thumbnail = this.elements.thumbnails.querySelector(
                    `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
                );
                this.setActiveThumbnail(thumbnail);
            }

            setActiveMedia(mediaId, prepend) {
                const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
                if (!activeMedia) return;

                this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
                    element.classList.remove('is-active');
                });
                activeMedia.classList.add('is-active');

                if (prepend) {
                    activeMedia.parentElement.prepend(activeMedia);
                    if (this.elements.thumbnails) {
                        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
                        if (activeThumbnail) activeThumbnail.parentElement.prepend(activeThumbnail);
                    }
                    if (this.elements.viewer.slider) this.elements.viewer.resetPages();

                    if (window.swiper2) {
                        window.swiper2.update();
                        window.swiper2.slideTo(0);
                        if (window.swiper2.thumbs && window.swiper2.thumbs.swiper) {
                            window.swiper2.thumbs.swiper.update();
                            window.swiper2.thumbs.swiper.slideTo(0);
                        }
                    }
                }

                this.preventStickyHeader();
                window.setTimeout(() => {
                    if (this.elements.thumbnails) {
                        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
                        this.setActiveThumbnail(activeThumbnail);
                    }
                    if (!prepend || !this.elements.viewer.slider) return;

                });

                // Scroll to the active media
                if (window.swiper2) {
                    const slideIndex = Array.from(this.elements.viewer.querySelectorAll('.swiper-slide')).indexOf(activeMedia);
                    if (slideIndex >= 0) {
                        window.swiper2.slideTo(slideIndex);
                    }
                } else {
                    if (!this.elements.viewer.sliderItemsToShow) return;
                    const slideIndex = Array.from(this.elements.viewer.sliderItemsToShow).indexOf(activeMedia);
                    if (slideIndex >= 0 && this.elements.viewer.slider) {
                        const scrollLeft = slideIndex * this.elements.viewer.sliderItemOffset;
                        this.elements.viewer.slider.scrollTo({ left: scrollLeft, behavior: 'smooth' });
                    }
                }
            }

            setActiveThumbnail(thumbnail) {
                if (!this.elements.thumbnails || !thumbnail) return;
                this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
                thumbnail.querySelector('button').setAttribute('aria-current', true);

                if (window.swiper2 && window.swiper2.thumbs && window.swiper2.thumbs.swiper) {
                    const slideIndex = Array.from(this.elements.thumbnails.querySelectorAll('.swiper-slide')).indexOf(thumbnail);
                    if (slideIndex >= 0) {
                        window.swiper2.thumbs.swiper.slideTo(slideIndex);
                    }
                    return;
                }

                if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

                this.elements.thumbnails.slider.scrollTo({
                    left: thumbnail.offsetLeft,
                });
            }

            preventStickyHeader() {
                this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
                if (!this.stickyHeader) return;
                this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
            }
        }
    );
}
